import { ISingleImageData } from '@ConfigLoader/ConfigFiles';
import { TDeviceInfo } from '@Managers/Redux/AppState/AppState.types';

function jsonValid(data: string) {
    const jsonValid = data
        .replace(/[{}]/g, '')
        .split(';')
        .filter((p) => p.trim())
        .map((p) => {
            return p.replace(/([a-zA-Z0-9_]+)\s*:\s*(.*)/, '"$1": "$2"');
        })
        .join(', ');

    const finalJson = `{${jsonValid}}`;

    return finalJson;
}

export function getImageStylesResolver(data: ISingleImageData, device: TDeviceInfo) {
    let styles = {};
    let orientationStyles = {};

    if (data.styles) {
        styles = JSON.parse(jsonValid(data.styles));
    }

    if (device.windowOrientationHorizontal && data.stylesHorizontal) {
        orientationStyles = JSON.parse(jsonValid(data.stylesHorizontal));
    }

    if (device.windowOrientationPortrait && data.stylesPortrait) {
        orientationStyles = JSON.parse(jsonValid(data.stylesPortrait));
    }

    return { ...styles, ...orientationStyles };
}
